import React, { Component } from 'react'

// Components
import Modal from '../modal/Modal'
import Button from '../modal/Button'
import Loader from './Loader'
import LocationMap from './maps/LocationMap'

// CSS
import '../../css/permalinks.css'

class GeolocationField extends Component {
    constructor(props){
        super(props)
        this.state = {
            showModal: false
        }
    }

    handleInputChange(event) {
        const value = event.target.value
        this.props.handleChange(value)
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault()
            this.props.handleSubmit()
        }
    }

    render() {
        const { value, placeholder, error } = this.props
        const { showModal } = this.state

        return (
            <div className="permalink_field_wrapper">
                {error &&
                    <div className="error msg_animate">{error}</div>
                }
                <input tabIndex="-1" type="text" value={value} className="permalink_input" placeholder={placeholder}
                    onKeyPress={e => this.handleKeyPress(e)}
                    onChange={e => this.handleInputChange(e)}
                />
                <div className="icon_wrapper active icon_button" onClick={() => this.setState({ showModal: true })}>
                    <div className="icon-location"></div>
                </div>

                {/* ADDRESS MODAL */}
                {showModal &&
                    <Modal title={'Choose Address'} buttons={[
                        {
                            type: Button,
                            text: 'Close',
                            action: () => this.setState({ showModal: false }),
                            disabled: this.props.deleteInProcess
                        }
                    ]}>
                        {value !== '' ? (
                            <LocationMap
                                address={value}
                                loadingElement={<Loader />}
                                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyA2mfXsrW3E8ZKx7pxKPFBRy-qE-wAEgOg&libraries=places"
                            />
                        ) : (
                            <div>Please enter a postal code</div>
                        )}
                    </Modal>
                }
            </div>
        )
    }
}

export default GeolocationField



// WEBPACK FOOTER //
// ./src/components/utils/GeolocationField.js